import Alpine from "alpinejs";
import { embedYtScript } from "../../modules/chc/youtube";

Alpine.magic("embedYtScriptCHC", () => (player, config = { autoplay: false }) => {
    return embedYtScript(player, config);
});
